<!-- 订单产品续订 -->
<template>
    <!--添加界面-->
      <el-dialog class="model-renew-form" width="850px" title="续费" :visible.sync="myVisible" :destroy-on-close="true" @close="handerClose"
        :close-on-click-modal="false">
        <div class="renew-content" v-if="myDetail">
           <!-- <header class="renew-hd">订单账户：{{ myDetail.ower }}</header> -->
           <section class="renew-bd">
             <el-table class="selected-product-tab" tooltip-effect="dark" :data="[myDetail]" style="width: 100%;" empty-text="还没有选择产品">
              <el-table-column prop="logo" header-align="center" align="center" width="100px" label="产品图片">
                <template slot-scope="scope">
                  <img  :src="scope.row.logo" :alt="scope.row.logo" class="tpimg">
                </template>
              </el-table-column>

              <el-table-column prop="name" label="产品名称" min-width="140" show-overflow-tooltip></el-table-column>
        
              <el-table-column prop="purchaseNum" label="购买数量" min-width="100" >
                  <template slot-scope="{row,$index}">
                      <span >{{ row.purchaseNum }}</span>
                  </template>
              </el-table-column>

              <el-table-column prop="price" label="单价(元)" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="price">{{ scope.row.price.toLocaleString() }}</span>
                </template>
              </el-table-column>

               <el-table-column prop="purchaseMonth" label="续费时长(月)" min-width="100" >
                <template slot-scope="{row,$index}">
                    <el-input-number v-model="row.purchaseMonth" :min="1" size="small" :step-strictly="true" controls-position="right" @change="handleChangeNum" ></el-input-number>
                </template>
              </el-table-column>

            </el-table>
           </section>

          <footer :span="24" class="order-add-ft">
            <el-form :inline="true"   >
                <el-col :span="24">
                  <el-form-item label="预估价格:" class="order-evaluate" style="color: #EB6264">
                    {{ evaluatePrice }} 元
                  </el-form-item> 
                </el-col>

              <el-col :span="24">
                  <el-form-item label="订单总价:" class="order-total">
                    <el-input class="price"  oninput="this.value=this.value.replace(/[^\d]/g,'');" v-model="totalPrice" style="width:200px;">
                        <template slot="append">元</template>
                    </el-input>
                  </el-form-item>
              </el-col>
            </el-form>
          </footer>
        </div>
        
        <div slot="footer" class="dialog-footer" style="text-align:center" v-if="myDetail">
          <el-button @click.native="handerClose">取消</el-button>
          <el-button type="primary" @click.native="handerSubmit(myDetail)" :loading="confirmLoading">提交</el-button>
        </div>

      </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { API_Order } from '@/api/index.js'
import  utils  from '@/utils/index'
import PictureList from '@/components/PictureList'


export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },

    productInfo: {
      type: Object,
      default: () => null
    }
  
  },

  data () {
    return {
     
      confirmLoading: false,
      
      token:'',
      checkCode:'',
      myDetail: null,
      myVisible: false,
      totalPrice: 0,
    };
  },

  components: {
    PictureList
  },
  

  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    }),

    // 计算预估价格
    evaluatePrice() {
      let { purchaseNum, price, purchaseMonth } = this.myDetail
      let money = 0;
      money = purchaseNum * purchaseMonth * price;
      this.totalPrice = money
      return money
    },
  }, 
 
  created() {
    this.myVisible = this.visible
  },

  mounted() {
    let { token, checkCode } = utils.getParamsByCookie();
    this.token = token;
    this.checkCode = checkCode;
    this.myDetail = JSON.parse(JSON.stringify(this.productInfo))
    // 默认续费时长1个月
    this.myDetail.purchaseMonth = 1
  },

  methods: {
    // curItem.purchaseNum * curItem.purchaseMonth * curItem.price
    handleChangeNum(val, data, key) {
      console.log("val==", val, typeof val)
    },

    // 续费
    handerSubmit(processInfo) {
      console.log('processInfo==',processInfo )
      // id  //老订单id
      // productId  //续订产品
      // purchaseMonth  //续订时长
      // price  //总价
      // singlePrice  //单件
      let { orderId, singlePrice, productId, purchaseMonth } = processInfo
      let data = {
        id: orderId,
        productId,
        purchaseMonth,
        price: this.totalPrice,
        singlePrice,
      }
       this.confirmLoading = true;
     
       API_Order.renewOrder(data).then(res => {
          if(res.data.code == 200) {
            this.$message.success('续订成功');
            this.$emit('getDetail')
            this.handerClose();
          }
          this.confirmLoading = false;
        }).catch( err => {
          this.confirmLoading = false;
        })
    },

    handerClose() {
      this.myVisible = false;
      this.$emit('update:visible', false)
    },
   
  }
}

</script>
<style lang='scss'>
.model-renew-form {
  .renew-hd {
    margin-bottom: 16px;
    color: #666;
    font-size: 14px;
  }
  .el-form-item {
    margin-bottom: 0;
  }

   .order-add-ft {
    width: 100%;
    padding: 6px 20px 0 20px;
    margin-top: 10px;
    padding-bottom: 0;
    border-top: 1px solid #F7F7F8;
    overflow: hidden;
    text-align: right;
    box-sizing: border-box;
      .el-form-item {
      margin: 0;
     }

     .el-input-group__append, .el-input-group__prepend {
       color: #666;
     }

     .order-total {
       .price {
         position: relative;
        top: 5px
       }
     }
  }
}
</style>


// WEBPACK FOOTER //
// ModalFormOrder.vue?0ad377a6